import script from "./AdapButtom.vue?vue&type=script&setup=true&lang=js"
export * from "./AdapButtom.vue?vue&type=script&setup=true&lang=js"

import "./AdapButtom.vue?vue&type=style&index=0&id=34a365c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a365c2"]])

export default __exports__